import React from "react";
/* TODO html코드에서 줄바꿈 만들기 */
export var customTextAreaAddBr = function (message) {
    if (!message)
        return false;
    return (message.split('\n').map(function (v) {
        return (React.createElement(React.Fragment, null,
            v,
            React.createElement("br", null)));
    }));
};
export var hiddenMessage = function (message, hidden) {
    if (hidden === 0) {
        return (React.createElement("span", { className: 'caution' }, customTextAreaAddBr(message)));
    }
    if (hidden === 1) {
        return (React.createElement("span", { className: 'caution' }, "\uAD00\uB9AC\uC790\uC5D0 \uC758\uD574 \uBE44\uB178\uCD9C \uCC98\uB9AC\uB41C \uC0C1\uD488\uD3C9\uC785\uB2C8\uB2E4."));
    }
    if (hidden === 2) {
        return (React.createElement("span", { className: 'caution' }, "\uC791\uC131\uC790\uC5D0 \uC758\uD574 \uC0AD\uC81C\uB41C \uC0C1\uD488\uD3C9\uC785\uB2C8\uB2E4."));
    }
    if (hidden === 3) {
        return (React.createElement("span", { className: 'caution' }, "\uC2E0\uACE0\uC5D0 \uC758\uD574 \uBE44\uB178\uCD9C \uCC98\uB9AC\uB41C \uC0C1\uD488\uD3C9\uC785\uB2C8\uB2E4."));
    }
};
/* TODO IP 변경 */
export var customIp = function (ip) {
    var customIp = ip.split('.');
    if (customIp) {
        customIp[1] = '***';
        return customIp.join('.');
    }
};
/* TODO 소수 첫째자리 반올림 */
export var customScore0Icon = function (score) {
    var newScore = Math.floor(score).toFixed(1); //정수 추출
    return scoreIcon(Number(newScore));
};
/* TODO 점수에따라 별 표시 */
var scoreIcon = function (score) {
    var className = "pc_shopping_icons_star_".concat((score % 2 === 0 ? score / 2 : (score / 2) * 10 === 5 ? '05' : (score / 2) * 10));
    return (React.createElement("span", { className: className },
        React.createElement("span", { className: "path1" }),
        React.createElement("span", { className: "path2" }),
        React.createElement("span", { className: "path3" }),
        React.createElement("span", { className: "path4" }),
        React.createElement("span", { className: "path5" }),
        score % 2 !== 0 && React.createElement("span", { className: "path6" })));
};
/* TODO 소수 첫째자리로 둘째자리 반올림 */
export var customScore00 = function (score) {
    if (Number.isInteger(score) || (score * 10) % 10 === 0) {
        return score;
    }
    else {
        return Math.round(score * 10) / 10;
    }
};
//TODO 최대 글자 제한
export var getInputTextMax = function (e, maxLength) {
    var value = e.target.value;
    // // 연속된 공백을 단일 공백으로 대체
    // const sanitizedValue = value.replace(/\s+/g, ' ');
    // // 첫 글자가 공백인 경우, 첫 글자를 제외한 나머지 문자열을 사용
    // if (sanitizedValue.charAt(0) === ' ') {
    //     return sanitizedValue.substr(1, maxLength);
    // }
    if (value.length > maxLength) {
        return value.substr(0, maxLength);
    }
    return value;
};
/*TODO 숫자 콤마*/
export var numberWithCommas = function (x) {
    if (x) {
        var parts = x.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
    }
    else {
        return '0';
    }
};
/* TODO 닉네임 변경 */
export var customNickName = function (name) {
    if (name === void 0) { name = ''; }
    var userNameIndex = name.indexOf('@');
    if (userNameIndex === -1) {
        return name;
    }
    else {
        return name.substring(0, userNameIndex);
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/review/libs/fn.tsx
// module id = 11
// module chunks = 0